import { render, staticRenderFns } from "./poalineaaccion.vue?vue&type=template&id=7b2059fc&scoped=true&"
import script from "./poalineaaccion.vue?vue&type=script&lang=ts&"
export * from "./poalineaaccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2059fc",
  null
  
)

export default component.exports